import React from "react";

type GradientCardProps = {
  children: React.ReactNode;
  topBorderColor?: string;
  sideGradientColors?: {
    from: string;
    to: string;
  };
  gradientBorderClass?: string; 
  className?: string;
  innerClassName?: string;
};

const GradientCard: React.FC<GradientCardProps> = ({
  children,
  topBorderColor = "skyBlue",
  sideGradientColors,
  gradientBorderClass,
  className = "",
  innerClassName = "",
}) => {
  // Convert Tailwind color name to CSS class
  const getBorderClass = (color: string) => {
    const colorMap: { [key: string]: string } = {
      skyBlue: "border-skyBlue",
      orange: "border-orange", 
      pink: "border-pink",
      yellow: "border-yellow",
      primary: "border-primary",
      green: "border-green",
      purple: "border-purple",
      limeGreen: "border-limeGreen"
    };
    return colorMap[color] || `border-${color}`;
  };



  // For gradient borders, we need to create a wrapper approach
  if (sideGradientColors || gradientBorderClass) {
    return (
      <div
        className={`relative rounded-2xl p-[2px] ${gradientBorderClass || ''} ${className}`}
        style={{
          background: sideGradientColors
            ? `linear-gradient(180deg, ${sideGradientColors.from}80, ${sideGradientColors.to}80)`
            : undefined,
        }}
      >
        {/* Inner white card */}
        <div className="bg-white h-full overflow-hidden border-t-8"
          style={{
            borderRadius: 'calc(1rem - 2px)',
            borderTopColor: sideGradientColors?.from ? `${sideGradientColors.from}80` : getBorderClass(topBorderColor).replace('border-', '#'),
          }}
        >
          <div className={`h-full ${innerClassName}`}>
            {children}
          </div>
        </div>
      </div>
    );
  }
  

  // Fallback for cards without gradient borders
  return (
    <div className={`bg-white rounded-2xl border-t-8 ${getBorderClass(topBorderColor)} ${className}`}>
      <div className={`p-6 h-full ${innerClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default GradientCard;
